/* Options:
Date: 2024-08-15 16:44:21
Version: 8.22
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://ortservices.dabto.com

//GlobalNamespace:
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion:
//AddDescriptionAsComments: True
//IncludeTypes:
//ExcludeTypes:
//DefaultImports:
*/

import {ValidationRuleType} from "devextreme/common";

export class BaseRequest_1<E>
{

  public constructor(init?: Partial<BaseRequest_1<E>>) { (Object as any).assign(this, init); }
}
export interface IReturn<T> {
  createResponse(): T;
}

export interface IReturnVoid {
  createResponse(): void;
}

export interface IHasSessionId {
  sessionId?: string;
}

export interface IHasBearerToken {
  bearerToken?: string;
}

export interface IPost {
}

export class BaseRequest<E> {

  public constructor(init?: Partial<BaseRequest<E>>) {
    (Object as any).assign(this, init);
  }
}

export enum MenuTypes {
  Module = 1,
  Branch = 2,
  Form = 3,
  ReportForm = 4,
  DashboardForm = 5,
  ExternalLink = 99,
}

export class MenuDto {
  public menuId: number;
  public parentId: number;
  public moduleId: number;
  public menuName: string;
  public menuTitle: string;
  public menuType: MenuTypes;
  public formId: number;
  public formName: string;
  public reportName: string;
  public icon: string;
  public url: string;
  public activeYn: boolean;
  public order: number;
  public subMenus?: MenuDto[];
  public items: MenuDto[];

  public constructor(init?: Partial<MenuDto>) {
    (Object as any).assign(this, init);
  }
}

export enum FormTypes {
  ListForm = 1,
  DetailForm = 2,
  ReportForm = 11,
  MultiReportForm = 12,
  BIForm = 21,
}

export class FormYetkiDto {
  public formCode?: string;
  public insertYn?: boolean;
  public updateYn?: boolean;
  public deleteYn?: boolean;
  public executeYn?: boolean;
  public exportYn?: boolean;
  public yetkiler?: string[];

  public constructor(init?: Partial<FormYetkiDto>) {
    (Object as any).assign(this, init);
  }
}


export class ParamDto {
  public key: string;
  public value: string;

  public constructor(init?: Partial<ParamDto>) {
    (Object as any).assign(this, init);
  }
}

export enum FormActionTypes {
  ServiceCall = 1,
  OpenReport = 2,
  OpenForm = 3,
  Other = 9,
}

export class FormActionDto {
  public formYer: string;
  public islemAd: string;
  public islemBaslik: string;
  public islemHint: string;
  public islemType: FormActionTypes;
  public islemTipi: string;
  public islemDetay: string;
  public yetkiAd: string;
  public icon: string;
  public aktifYn: boolean;
  public orderIndex:number
  public bStyle: string;
  public bStylingMode: string;
  public bType: string;
  public bWitdh?: number;
  public donemKontrolYn?: boolean;
  public bTextVisibleYn: boolean;

  public constructor(init?: Partial<FormActionDto>) {
    (Object as any).assign(this, init);
  }
}

export class ValidatorDto {
  public type: ValidationRuleType;
  public min: number;
  public max: number;
  public iev: boolean;
  public mes?: string;
  public pattern?: string;

  public constructor(init?: Partial<ValidatorDto>) {
    (Object as any).assign(this, init);
  }
}

export class DlistFieldDto {
  public activeYn: boolean;
  public allowGroupYn: boolean;
  public allowHidingYn: boolean;
  public allowSortYn: boolean;
  public allowFilterYn: boolean;
  public visibleYn: boolean;
  public editYn: boolean;
  public fixedYn: boolean;
  public fixedPosition: string;
  public caption?: string;
  public dataField?: string;
  public dataLength?: number;
  public dataPrecision?: number;
  public dataScale?: number;
  public dataType?: string;
  public format?: string;
  public pattern?: string;
  public id: number;
  public labelText?: string;
  public lookup?: string;
  public nullable: boolean;
  public orderIndex: number;
  public sortOrder?: string;
  public sortIndex: number;
  public groupIndex?: number;
  public totalFormula?: string;
  public width: number;
  public viewTemplate?: string;
  public defaultFilter?: string;
  public options?: ParamDto[];
  public validators?: ValidatorDto[];
  public pivotArea?: string;
  public pivotSummary?: string;
  public chartArea?: string;
  public chartSummary?: string;
  public editorOptions?: EditorOptionDto;

  public constructor(init?: Partial<DlistFieldDto>) {
    (Object as any).assign(this, init);
  }
}

/**
 * GEN_SORGU_AYAR'ın (SorguId+AyarGrup+AyarKod+KolonAdi+AyarDeger) satır karşılığı.
 * AyarGrup backend'de zaten filtrelenip gönderildiği için burada yok - tüketici
 * (örn. dk-gen-chart) sadece kendi grubunun (CHART) satırlarını görür.
 * kolonAdi boşsa ayar sorgu genelinedir, doluysa o kolona özeldir.
 */
export interface ChartSettingDTO {
  ayarKod: string;
  kolonAdi?: string;
  ayarDeger: string;
}

export class DlistDto {
  public allowExportpdfYn: boolean;
  public allowExportxlsYn: boolean;
  public allowFilterYn: boolean;
  public allowGroupingYn: boolean;
  public allowPagingYn: boolean;
  public allowSelectionYn: boolean;
  public allowTotalbarYn: boolean;
  public columnChooserYn: boolean;
  public dlistCode: string;
  public dlistName: string;
  public id: number;
  public pageCount: number;
  public params: string;
  public showActioncolumnYn: boolean;
  public showFilterYn: boolean;
  public showGroupingYn: boolean;
  public showPagingYn: boolean;
  public showSelectionYn: boolean;
  public showSettingYn: boolean;
  public showTotalbarYn: boolean;
  public fields: DlistFieldDto[];
  public allowSearchYn: boolean;
  public showSearchYn: boolean;
  public allowStateYn: boolean;
  public allowAddingYn: boolean;
  public allowUpdatingYn: boolean;
  public allowDeletingYn: boolean;
  public editMode: string;
  public orderBy: string;
  public baseEntity: string;
  public historyEntity: string;
  public lineCount: number;
  public multilineHeaderYn: boolean;
  public multilineItemYn: boolean;
  public select: string[];
  public allowPivotYn:boolean;
  public allowChartYn:boolean;
  public chartType?: string;
  public chartSettings?: ChartSettingDTO[];

  public constructor(init?: Partial<DlistDto>) {
    (Object as any).assign(this, init);
  }
}

export class EditorOptionDto
{
    public min: number;
    public max: number;
    public format: string;
    public height: string;
    public width: string;
    public mask: string;
    public inputAttr: string;

    public constructor(init?: Partial<EditorOptionDto>) { (Object as any).assign(this, init); }
}

export class FormDto {
  public formId: number;
  public formName: string;
  public formCode: string;
  public formTitle: string;
  public formType: FormTypes;
  public icon: string;
  public link: string;
  public detayTakipYn:boolean
  public formYetki: FormYetkiDto;
  public formParams: ParamDto[];
  public formActions: FormActionDto[];
  public formListMetaData: DlistDto;

  public constructor(init?: Partial<FormDto>) {
    (Object as any).assign(this, init);
  }
}

export class LookupItem {
  public kod: number;
  public ozelKod: string;
  public aciklama: string;

  public constructor(init?: Partial<LookupItem>) {
    (Object as any).assign(this, init);
  }
}

export class ControlMetadataDto {
  public controlCode: string;
  public controlDescription: string;
  public defaultOrder?: string;
  public descriptionField: string;
  public dlistCode: string;
  public donemYn: boolean;
  public filterColumns?: string;
  public kodField: string;
  public searchColumns?: string;
  public valueField: string;
  public dlistMetadata: DlistDto;

  public constructor(init?: Partial<ControlMetadataDto>) {
    (Object as any).assign(this, init);
  }
}

export class KullaniciBilgiDto {

  public kullaniciKod: number;
  public kullaniciAd: string;
  public adi: string;
  public soyadi: string;
  public personelKod: number;
  public email: string;
  public telefon: string;
  public isAdmin: boolean;

  public constructor(init?: Partial<KullaniciBilgiDto>) { (Object as any).assign(this, init); }
}

export class PersonelBilgiDto
{
    public ad: string;
    public cinsiyet: string;
    public dogumTarih: string;
    public eMail: string;
    public gorevBirimKod: number;
    public gsmTelefon: string;
    public ilkGirisTarih: string;
    public kadroBirimKod: number;
    public kisiKod: number;
    public kod: number;
    public kurumSicilNo: string;
    public mailBilgiEh: string;
    public personelKod: number;
    public personelTurKod: number;
    public personelTurAd: string;
    public smsBilgiEh: string;
    public soyad: string;
    public sskNo: string;
    public tasarrufNo: string;
    public tckn: string;
    public yetkiliBirimler: string[];
    public gorevBirimAd: string;
    public kadroBirimAd: string;
    public personelResim: string;
    public malBeyanEh: string;
    public sendikaEh: string;
    public kepPosta : string;
    public dahiliTelefon : string;

    public constructor(init?: Partial<PersonelBilgiDto>) { (Object as any).assign(this, init); }
}
export class GorevOzet {
  public gorevKod: string;
  public gorevAd: string;
  public icon: string;
  public textColor: string;
  public bekleyenAdet: number;
  public tamamlananAdet01: number;
  public tamamlananAdet07: number;
  public tamamlananAdet30: number;
  public tamamlananAdet360: number;

  public constructor(init?: Partial<GorevOzet>) {
    (Object as any).assign(this, init);
  }
}

export enum InputType {
  DevItem = 1,
  Controller = 2,
  Lookup = 3,
  MultiLookup = 4,
}

export class ReportParams {
  public paramCode: string;
  public paramTitle: string;
  public paramType: string;
  public inputType: InputType;
  public paramType2: string;
  public paramType3: string;
  public group: string;
  public defaultValue: string;
  public outputValue: string;
  public inputOrder: number;
  public inputColumnOrder: number;
  public requiredYn: boolean;
  public visibilityYn: boolean;
  public inputMinValue: string;
  public inputMaxValue: string;

  public constructor(init?: Partial<ReportParams>) {
    (Object as any).assign(this, init);
  }
}

export class MultiReportParam {
  public parentRaport: string;
  public reportUrl: string;
  public reportName: string;

  public constructor(init?: Partial<MultiReportParam>) {
    (Object as any).assign(this, init);
  }
}

export class Report {
  public reportCode: string;
  public reportUrl: string;
  public onlineYn: boolean;
  public taskYn: boolean;
  public aktifYn: boolean;
  public multiReportYn: boolean;
  public reportTitle: string;
  public reportType: string;
  public reportColumns?: string[];
  public reportContent?: string;
  public devReportParams: ReportParams[];
  public ctlReportParams: ReportParams[];
  public lkpReportParams: ReportParams[];
  public multiLkpReportParams: ReportParams[];
  public multiReportParams?: MultiReportParam[];
  public validations: string[];

  public constructor(init?: Partial<Report>) {
    (Object as any).assign(this, init);
  }
}

export class DABDashboardParameter {
  public parameterName: string;
  public parameterDefaultValue: string;
  public parameterCode: string;
  public parameterType: string;

  public constructor(init?: Partial<DABDashboardParameter>) {
    (Object as any).assign(this, init);
  }
}

export class DABDashboard {
  public dashboardName: string;
  public dashboardId: string;
  public dashboardTitle: string;
  public dashboardXmlContent: string;
  public hasParameter: boolean;
  public parameterTotalCount?: number;
  public birimTuru?:string;
  public parameters: DABDashboardParameter[];

  public constructor(init?: Partial<DABDashboard>) {
    (Object as any).assign(this, init);
  }
}

export class DABDashboardGroup {
  public dashboardGroupName: string;
  public dashboardGroupDescription: string;
  public dashboardTotalCount: number;
  public dashboards: DABDashboard[];

  public constructor(init?: Partial<DABDashboardGroup>) {
    (Object as any).assign(this, init);
  }
}

// @DataContract
export class ResponseError {
  // @DataMember(Order=1)
  public errorCode: string;

  // @DataMember(Order=2)
  public fieldName: string;

  // @DataMember(Order=3)
  public message: string;

  // @DataMember(Order=4)
  public meta: { [index: string]: string; };

  public constructor(init?: Partial<ResponseError>) {
    (Object as any).assign(this, init);
  }
}

// @DataContract
export class ResponseStatus {
  // @DataMember(Order=1)
  public errorCode: string;

  // @DataMember(Order=2)
  public message: string;

  // @DataMember(Order=3)
  public stackTrace: string;

  // @DataMember(Order=4)
  public errors: ResponseError[];

  // @DataMember(Order=5)
  public meta: { [index: string]: string; };

  public constructor(init?: Partial<ResponseStatus>) {
    (Object as any).assign(this, init);
  }
}

export class BaseResponse {
  public result: boolean;
  public errorCode: string;
  public errorMessage: string;
  public errors: string[];
  public warnings: string[];
  public errorDetails: string[];
  public totalPages: number;
  public totalCount: number;
  public pageSize: number;

  public constructor(init?: Partial<BaseResponse>) {
    (Object as any).assign(this, init);
  }
}

export class GetMenuTree_Response extends BaseResponse {
  public menuList: MenuDto[];

  public constructor(init?: Partial<GetMenuTree_Response>) {
    super(init);
    (Object as any).assign(this, init);
  }
}

export class GetFormMetadata_Response extends BaseResponse {
  public formMetadata: FormDto;

  public constructor(init?: Partial<GetFormMetadata_Response>) {
    super(init);
    (Object as any).assign(this, init);
  }
}

/* export class GetLookup_Response extends BaseResponse {
  public items: LookupItem[];

  public constructor(init?: Partial<GetLookup_Response>) {
    super(init);
    (Object as any).assign(this, init);
  }
} */

export class GetControlMetadata_Response extends BaseResponse {
  public controlMetadata: ControlMetadataDto;
  public dListMetadata: DlistDto;

  public constructor(init?: Partial<GetControlMetadata_Response>) {
    super(init);
    (Object as any).assign(this, init);
  }
}

export class GetDlist_Response extends BaseResponse {
  public dListMetadata: DlistDto;

  public constructor(init?: Partial<GetDlist_Response>) {
    super(init);
    (Object as any).assign(this, init);
  }
}

export class GetKullaniciBilgi_Response extends BaseResponse {

    public isKullanici: boolean;
    public kullaniciBilgi: KullaniciBilgiDto;
    public isPersonel: boolean;
    public personelBilgi: PersonelBilgiDto;
    public canUseDaBApp: boolean;
    public message: string;
    public constructor(init?: Partial<GetKullaniciBilgi_Response>) { super(init); (Object as any).assign(this, init); }

}

export class GetPersonelBilgi_Response extends BaseResponse
{
    public isPersonel: boolean;
    public personelBilgi: PersonelBilgiDto;

    public constructor(init?: Partial<GetPersonelBilgi_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GetKullaniciAd_Response extends BaseResponse
{
    public kayitKullaniciAd: string;
    public degisKullaniciAd: string;

    public constructor(init?: Partial<GetKullaniciAd_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GetGorevOzet_Response extends BaseResponse {
  public gorevOzetListesi: GorevOzet[];

  public constructor(init?: Partial<GetGorevOzet_Response>) {
    super(init);
    (Object as any).assign(this, init);
  }
}

export class DABReport_Response extends BaseResponse {
  public report: Report;

  public constructor(init?: Partial<DABReport_Response>) {
    super(init);
    (Object as any).assign(this, init);
  }
}

export class DABReportGroup_Response extends BaseResponse {
  public reportGroupCode: string;
  public reportGroupTitle: string;
  public reports: Report[];
  public reportGroupType:string;

  public constructor(init?: Partial<DABReportGroup_Response>) {
    super(init);
    (Object as any).assign(this, init);
  }
}

export class DABDashboard_Response extends BaseResponse {
  public group: DABDashboardGroup;

  public constructor(init?: Partial<DABDashboard_Response>) {
    super(init);
    (Object as any).assign(this, init);
  }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken {
  // @DataMember(Order=1)
  public userId: string;

  // @DataMember(Order=2)
  public sessionId: string;

  // @DataMember(Order=3)
  public userName: string;

  // @DataMember(Order=4)
  public displayName: string;

  // @DataMember(Order=5)
  public referrerUrl: string;

  // @DataMember(Order=6)
  public bearerToken: string;

  // @DataMember(Order=7)
  public refreshToken: string;

  // @DataMember(Order=8)
  public refreshTokenExpiry?: string;

  // @DataMember(Order=9)
  public profileUrl: string;

  // @DataMember(Order=10)
  public roles: string[];

  // @DataMember(Order=11)
  public permissions: string[];

  // @DataMember(Order=12)
  public responseStatus: ResponseStatus;

  // @DataMember(Order=13)
  public meta: { [index: string]: string; };

  public constructor(init?: Partial<AuthenticateResponse>) {
    (Object as any).assign(this, init);
  }
}

// @DataContract
export class AssignRolesResponse {
  // @DataMember(Order=1)
  public allRoles: string[];

  // @DataMember(Order=2)
  public allPermissions: string[];

  // @DataMember(Order=3)
  public meta: { [index: string]: string; };

  // @DataMember(Order=4)
  public responseStatus: ResponseStatus;

  public constructor(init?: Partial<AssignRolesResponse>) {
    (Object as any).assign(this, init);
  }
}

// @DataContract
export class UnAssignRolesResponse {
  // @DataMember(Order=1)
  public allRoles: string[];

  // @DataMember(Order=2)
  public allPermissions: string[];

  // @DataMember(Order=3)
  public meta: { [index: string]: string; };

  // @DataMember(Order=4)
  public responseStatus: ResponseStatus;

  public constructor(init?: Partial<UnAssignRolesResponse>) {
    (Object as any).assign(this, init);
  }
}

// @Route("/System/GetMenuTree", "POST")
export class GetMenuTree_Request extends BaseRequest<GetMenuTree_Response> implements IReturn<GetMenuTree_Response> {
  public modulId: number;
  public app: string;
  public modulList: string;
  public searchText: string;

  public constructor(init?: Partial<GetMenuTree_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'GetMenuTree_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new GetMenuTree_Response();
  }
}

// @Route("/System/GetFormMetadata", "POST")
export class GetFormMetadata_Request extends BaseRequest<GetFormMetadata_Response> implements IReturn<GetFormMetadata_Response> {
  public formAd: string;
  public altFormAd: string;
  public kod: number;
  public logYn: boolean;

  public constructor(init?: Partial<GetFormMetadata_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'GetFormMetadata_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new GetFormMetadata_Response();
  }
}

// @Route("/System/FormAction", "POST")
export class FormAction_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse> {
  public formAd: string;
  public kod: number;

  public constructor(init?: Partial<FormAction_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'FormAction_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new BaseResponse();
  }
}

// // @Route("/System/ReportAction", "POST")
// export class ReportAction_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse> {
//   public reportName: string;
//   public islem: string;
//   public parametre: string;
//   public hedef: string;
//   public kaynak: string;

//   public constructor(init?: Partial<ReportAction_Request>) {
//     super(init);
//     (Object as any).assign(this, init);
//   }

//   public getTypeName() {
//     return 'ReportAction_Request';
//   }

//   public getMethod() {
//     return 'POST';
//   }

//   public createResponse() {
//     return new BaseResponse();
//   }
// }

// @Route("/System/DListAction", "POST")
export class DListAction_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse> {
  public dListCode: string;
  public formAd: string;
  public islem: string;
  public filter: string;
  public kayıtAdedi: number;

  public constructor(init?: Partial<DListAction_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'DListAction_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new BaseResponse();
  }
}

// @Route("/System/AddForm2Favorite", "POST")
export class AddForm2Favorite_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse> {
  public formId: number;
  public autoOpenYn: boolean;
  public removeYn: boolean;

  public constructor(init?: Partial<AddForm2Favorite_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'AddForm2Favorite_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new BaseResponse();
  }
}

export class GetLookup_Response extends BaseResponse
{
    public size: number;
    public rowCount: number;
    public items: LookupItem[];

    public constructor(init?: Partial<GetLookup_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/System/GetLookup", "POST")
export class GetLookup_Request extends BaseRequest<GetLookup_Response> implements IReturn<GetLookup_Response>
{
    public lookupAd: string;
    public donemKod: number;
    public donem: number;
    public anaKod: number;
    public anaKodStr: string;
    public paramStr1: string;
    public paramStr2: string;
    public param1: number;
    public param2: number;
    public page: number;
    public count: number;
    public sendRowCount: boolean;

    public constructor(init?: Partial<GetLookup_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLookup_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetLookup_Response(); }
}

// @Route("/System/GetControlMetadata", "POST")
export class GetControlMetadata_Request extends BaseRequest<GetControlMetadata_Response> implements IReturn<GetControlMetadata_Response> {
  public controlCode: string;

  public constructor(init?: Partial<GetControlMetadata_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'GetControlMetadata_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new GetControlMetadata_Response();
  }
}

// @Route("/System/GetDList", "POST")
export class GetDlist_Request extends BaseRequest<GetDlist_Response> implements IReturn<GetDlist_Response> {
  public dListCode: string;

  public constructor(init?: Partial<GetDlist_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'GetDlist_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new GetDlist_Response();
  }
}

// @Route("/System/GetKullaniciBilgi", "POST")
export class GetKullaniciBilgi_Request extends BaseRequest<GetKullaniciBilgi_Response> implements IReturn<GetKullaniciBilgi_Response>
{
    public getPersonelBilgiYn: boolean;
    public device: string;

    public constructor(init?: Partial<GetKullaniciBilgi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetKullaniciBilgi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetKullaniciBilgi_Response(); }
}

// @Route("/System/GetKullaniciAd", "POST")
export class GetKullaniciAd_Request extends BaseRequest<GetKullaniciAd_Response> implements IReturn<GetKullaniciAd_Response>
{
    public kayitKullaniciKod: number;
    public degisKullaniciKod: number;

    public constructor(init?: Partial<GetKullaniciAd_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetKullaniciAd_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetKullaniciAd_Response(); }
}

// @Route("/System/GetPersonelBilgi", "POST")
export class GetPersonelBilgi_Request extends BaseRequest<GetPersonelBilgi_Response> implements IReturn<GetPersonelBilgi_Response>
{
    public personelKod: number;

    public constructor(init?: Partial<GetPersonelBilgi_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonelBilgi_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetPersonelBilgi_Response(); }
}
// @Route("/System/GetGorevOzet", "POST")
export class GetGorevOzet_Request extends BaseRequest<GetGorevOzet_Response> implements IReturn<GetGorevOzet_Response> {
  public kriter: string;

  public constructor(init?: Partial<GetGorevOzet_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'GetGorevOzet_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new GetGorevOzet_Response();
  }
}

// @Route("/System/Test", "POST")
export class Test_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse> {

  public constructor(init?: Partial<Test_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'Test_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new BaseResponse();
  }
}

// @Route("/System/Test_Talep_Request", "POST")
export class Test_Talep_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse> {

  public constructor(init?: Partial<Test_Talep_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'Test_Talep_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new BaseResponse();
  }
}

// @Route("/System/ReportExportSaver", "POST")
export class DABReportExportSaver_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse> {
  public reportCode: string;
  public format: string;
  public reportTitle: string;
  public reportParamsQuery: string;
  public mailSendYn: boolean;
  public emailAddress: string;
  public userMailAddress: string;

  public constructor(init?: Partial<DABReportExportSaver_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'DABReportExportSaver_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new BaseResponse();
  }
}

// @Route("/System/GetReport", "POST")
export class DABReport_Request extends BaseRequest<DABReport_Response> implements IReturn<DABReport_Response> {
  public reportCode: string;
  public selectedYear?: number;

  public constructor(init?: Partial<DABReport_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'DABReport_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new DABReport_Response();
  }
}

// @Route("/System/GetReportGroup", "POST")
export class DABReportGroup_Request extends BaseRequest<DABReportGroup_Response> implements IReturn<DABReportGroup_Response> {
  public reportGroupCode: string;

  public constructor(init?: Partial<DABReportGroup_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'DABReportGroup_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new DABReportGroup_Response();
  }
}

// @Route("/System/GetDashboard", "POST")
export class DABDashboard_Request extends BaseRequest<DABDashboard_Response> implements IReturn<DABDashboard_Response> {
  public dashboardGroupName: string;
  /** Analiz Merkezi: GEN_DASHBOARD.ID verilirse yalnız o dashboard döner (kutucuk yetkisiyle). */
  public dashboardKod?: number;

  public constructor(init?: Partial<DABDashboard_Request>) {
    super(init);
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'DABDashboard_Request';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new DABDashboard_Response();
  }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost {
  /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
  public provider: string;

  // @DataMember(Order=2)
  public userName: string;

  // @DataMember(Order=3)
  public password: string;

  // @DataMember(Order=4)
  public rememberMe?: boolean;

  // @DataMember(Order=5)
  public accessToken: string;

  // @DataMember(Order=6)
  public accessTokenSecret: string;

  // @DataMember(Order=7)
  public returnUrl: string;

  // @DataMember(Order=8)
  public errorView: string;

  // @DataMember(Order=9)
  public meta: { [index: string]: string; };

  public constructor(init?: Partial<Authenticate>) {
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'Authenticate';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new AuthenticateResponse();
  }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost {
  // @DataMember(Order=1)
  public userName: string;

  // @DataMember(Order=2)
  public permissions: string[];

  // @DataMember(Order=3)
  public roles: string[];

  // @DataMember(Order=4)
  public meta: { [index: string]: string; };

  public constructor(init?: Partial<AssignRoles>) {
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'AssignRoles';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new AssignRolesResponse();
  }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost {
  // @DataMember(Order=1)
  public userName: string;

  // @DataMember(Order=2)
  public permissions: string[];

  // @DataMember(Order=3)
  public roles: string[];

  // @DataMember(Order=4)
  public meta: { [index: string]: string; };

  public constructor(init?: Partial<UnAssignRoles>) {
    (Object as any).assign(this, init);
  }

  public getTypeName() {
    return 'UnAssignRoles';
  }

  public getMethod() {
    return 'POST';
  }

  public createResponse() {
    return new UnAssignRolesResponse();
  }
}

export class DABDynamicReport_Response extends BaseResponse
{
    public jsonResponse: string;
    public columnsInfo?: DlistFieldDto[];

    public constructor(init?: Partial<DABDynamicReport_Response>) { super(init); (Object as any).assign(this, init); }
}

export class DABDynamicReport_Request extends BaseRequest<DABDynamicReport_Response> implements IReturn<DABDynamicReport_Response>
{
    public reportCode: string;
    public sqlQuery: string;
    public sqlParams?: DynamicParams[];
    public columnList?: string[];
    public pageSize?: number;
    public pageNumber?: number;

    public constructor(init?: Partial<DABDynamicReport_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DABDynamicReport_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DABDynamicReport_Response(); }
}


export class DynamicParams
{
    public paramName: string;
    public paramCode: string;

    public constructor(init?: Partial<DynamicParams>) { (Object as any).assign(this, init); }
}



export class DABGetDynamicReportGroup_Response extends BaseResponse
{
    public dynamicReports: Report[];

    public constructor(init?: Partial<DABGetDynamicReportGroup_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/System/GetDynamicReportGroup", "POST")
export class DABGetDynamicReportGroup_Request extends BaseRequest<DABGetDynamicReportGroup_Response> implements IReturn<DABGetDynamicReportGroup_Response>
{
    public dynamicReportGroupCode?:string;
    public constructor(init?: Partial<DABGetDynamicReportGroup_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DABGetDynamicReportGroup_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DABGetDynamicReportGroup_Response(); }
}

export interface IBaseCursorDto
{
}

export class GorevSayacDto implements IBaseCursorDto
{
    public gorevTipi: string;
    public icon: string;
    public aciklama: string;
    public formName: string;
    public url: string;
    public statusu: number;
    public adet: number;

    public constructor(init?: Partial<GorevSayacDto>) { (Object as any).assign(this, init); }
}


export class GetGorevSayac_Response extends BaseResponse
{
    public gorevSayacList: GorevSayacDto[];

    public constructor(init?: Partial<GetGorevSayac_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/System/GetGorevSayac", "POST")
export class GetGorevSayac_Request extends BaseRequest<GetGorevSayac_Response> implements IReturn<GetGorevSayac_Response>
{
    public sayacTur: string;

    public constructor(init?: Partial<GetGorevSayac_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGorevSayac_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetGorevSayac_Response(); }
}



export class SetConnectedUser_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public subscriptionId?: string;
    public kullaniciKod: number;
    public channel: string;
    public connect: boolean;
    public deviceName:string;

    public constructor(init?: Partial<SetConnectedUser_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SetConnectedClient_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}



export class DABCustomBysReport_Response extends BaseResponse
{
    public ilkBelgeKod?: number;
    public sonBelgeKod?: number;

    public constructor(init?: Partial<DABCustomBysReport_Response>) { super(init); (Object as any).assign(this, init); }
}


export class GetRaporVarsayilanDeger_Response extends BaseResponse
{
    public ilkKod?: number;
    public sonKod?: number;

    public constructor(init?: Partial<GetRaporVarsayilanDeger_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/System/GetRaporVarsayilanDeger_Request", "POST")
export class GetRaporVarsayilanDeger_Request extends BaseRequest<GetRaporVarsayilanDeger_Response> implements IReturn<GetRaporVarsayilanDeger_Response>
{
    public raporAd: string;
    public donem?: number;
    public ilkTarih?: string;
    public sonTarih?: string;

    public constructor(init?: Partial<GetRaporVarsayilanDeger_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRaporVarsayilanDeger_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetRaporVarsayilanDeger_Response(); }
}

// @Route("/System/DABCustomBys_Report", "POST")
export class DABCustomBys_Report extends BaseRequest<DABCustomBysReport_Response> implements IReturn<DABCustomBysReport_Response>
{
    public ilkTarih?: string;
    public sonTarih?: string;

    public constructor(init?: Partial<DABCustomBys_Report>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DABCustomBys_Report'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DABCustomBysReport_Response(); }
}

export class DABGetReportDemandContent_Response extends BaseResponse
{
    public docContent?: string;
    public docType?: string;
    public docName?: string;

    public constructor(init?: Partial<DABGetReportDemandContent_Response>) { super(init); (Object as any).assign(this, init); }
}

export class DABGetReportDemandContent_Request extends BaseRequest<DABGetReportDemandContent_Response> implements IReturn<DABGetReportDemandContent_Response>
{
    public docId: number;

    public constructor(init?: Partial<DABGetReportDemandContent_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DABGetReportDemandContent_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DABGetReportDemandContent_Response(); }
}



// @Route("/System/SetDList") modedl
export class DxGridColumnDto
{
  public caption: string;
  public visibleIndex: number;
  public dataField: string;
  public name: string;
  public dataType: string;
  public width: number;
  public visible: boolean;
  public sortIndex: number;
  public sortOrder: string;
  public filterValue: string;
  public fixedPosition: string;

  public constructor(init?: Partial<DxGridColumnDto>) { (Object as any).assign(this, init); }
}



// @Route("/System/SetDList")
export class SetDlist_Request extends BaseRequest_1<GetDlist_Response> implements IReturn<GetDlist_Response>
{
  public dListCode: string;
  public resetYn: boolean;
  public rol: string;
  public dxColumns: DxGridColumnDto[];

  public constructor(init?: Partial<SetDlist_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'SetDlist_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GetDlist_Response(); }
}


export class SetBildirimOkundu_Response extends BaseResponse
{

    public constructor(init?: Partial<SetBildirimOkundu_Response>) { super(init); (Object as any).assign(this, init); }
}

export class SetBildirimOkundu_Request extends BaseRequest<SetBildirimOkundu_Response> implements IReturn<SetBildirimOkundu_Response>
{
    public bildirimKod?: number
    public silEh?: string;
    public tumuEh?: number;

    public constructor(init?: Partial<SetBildirimOkundu_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SetBildirimOkundu_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetBildirimOkundu_Response(); }
}


export class DABGetAllDynamicReportGroup_Response extends BaseResponse
{
    public sorguGroups: SorguGroup[];

    public constructor(init?: Partial<DABGetAllDynamicReportGroup_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/System/GetAllDynamicReportGroup", "POST")
export class DABGetAllDynamicReportGroup_Request extends BaseRequest<DABGetAllDynamicReportGroup_Response> implements IReturn<DABGetAllDynamicReportGroup_Response>
{

    public constructor(init?: Partial<DABGetAllDynamicReportGroup_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DABGetAllDynamicReportGroup_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DABGetAllDynamicReportGroup_Response(); }
}



export class SorguGroup
{
    public dynamicReportGroupCode: string;
    public dynamicReportGroupTitle: string;
    public dynamicReports: Report[];

    public constructor(init?: Partial<SorguGroup>) { (Object as any).assign(this, init); }
}




export class IkaGUI_PersonelIzin_Request implements IReturn<BaseResponse>
{
    public personelKod: number;
    public kontrolTarih?: string;

    public constructor(init?: Partial<IkaGUI_PersonelIzin_Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IkaGUI_PersonelIzin_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}

export class ReportAction_Response extends BaseResponse
{
    public report: string;

    public constructor(init?: Partial<ReportAction_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/System/ReportAction", "POST")
export class ReportAction_Request extends BaseRequest<ReportAction_Response> implements IReturn<ReportAction_Response>
{
    public reportName: string;
    public islem: string;
    public parametre: string;
    public hedef: string;
    public kaynak: string;
    public returnReportPdf: boolean;

    public constructor(init?: Partial<ReportAction_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportAction_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ReportAction_Response(); }
}